import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/use-auth";
import { useNavigate } from "react-router";
import { Heart } from "lucide-react";
import Loader from "./Loader";
import { useEffect } from "react";

export default function Landing() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Redirect based on authentication status
  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated) {
        navigate("/auth", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, navigate]);

  // Show loading while checking authentication
  if (isLoading) {
    return <Loader />;
  }

  // Don't render anything while redirecting
  return null;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary/5 to-secondary/5">
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="flex items-center gap-3 mb-8 cursor-pointer"
        onClick={() => navigate("/")}
      >
       <img className="max-w-60" src="/Logo_removeBg.png"/>
      </motion.div>

      {/* Main Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-center space-y-6 max-w-md"
      >
        <div className="space-y-3">
          <h2 className="text-4xl font-bold tracking-tight">
            Simplifying Chronic Care
          </h2>
          <p className="text-lg text-muted-foreground">
            Transform your healthcare practice with our comprehensive Chronic Care Management platform
          </p>
        </div>

        <Button
          size="lg"
          onClick={() => navigate(isAuthenticated ? "/dashboard" : "/auth")}
          className="w-full text-lg px-8 py-6"
        >
          {isAuthenticated ? "Go to Dashboard" : "Sign In"}
        </Button>
      </motion.div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="absolute bottom-8 text-center text-sm text-muted-foreground"
      >
        <p>© 2025 Anthro Care. All rights reserved.</p>
      </motion.div>
    </div>
  );
}